import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import { Labeled, Badge } from "@lifepay/rc-ui-toolkit";

import ProcessingAccess from "components/list-items/ProcessingAccess";

import AddProcessingUserAccess from "./AddProcessingUserAccess";
import RemoveProcessingUserAccess from "./RemoveProcessingUserAccess";
import styles from "./ProcessingUserAccesses.m.scss";

function ProcessingRole(props) {
  const { theme, roles, accesses, username, refetchUsers } = props;
  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme["role-accesses"])}>
        <Labeled
          label={"Доступы для ролей пользователя"}
          theme={{ value: theme.label }}
        >
          <div className={classnames(theme.content)}>
            {roles.map((role) =>
              role.accesses.map((access) => (
                <div
                  className={classnames(theme["role-access"])}
                  key={access.id}
                >
                  <Badge
                    type="blob"
                    theme={{
                      wrapper: theme["role-name"],
                    }}
                  >
                    {role.roleName}
                  </Badge>
                  <ProcessingAccess item={access} />
                </div>
              ))
            )}
          </div>
        </Labeled>
      </div>
      <div className={classnames(theme["user-accesses"])}>
        <Labeled
          label={
            <React.Fragment>
              {"Доступы пользователя"}
              <AddProcessingUserAccess
                username={username}
                onSuccess={refetchUsers}
              />
            </React.Fragment>
          }
          theme={{ value: theme.label }}
        >
          <div className={classnames(theme.content)}>
            {accesses.map((access) => (
              <div className={classnames(theme["user-access"])} key={access.id}>
                <ProcessingAccess item={access} />
                <RemoveProcessingUserAccess
                  username={username}
                  accessId={access.id}
                  onSuccess={refetchUsers}
                />
              </div>
            ))}
          </div>
        </Labeled>
      </div>
    </div>
  );
}

ProcessingRole.displayName = "ProcessingRole";

ProcessingRole.propTypes = {
  theme: PropTypes.object,
  roles: PropTypes.array,
  accesses: PropTypes.array,
  username: PropTypes.string,
  refetchUsers: PropTypes.func,
};

ProcessingRole.defaultProps = {};

export default themr("@lifepay/ProcessingRole", styles)(ProcessingRole);



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingUser/ProcessingUserAccesses/ProcessingUserAccesses.js